// extracted by mini-css-extract-plugin
module.exports = {"base":"ModalPopup_base__2JAC0","card":"ModalPopup_card__2u9ID"};